const stats = [
  { icon: "ri-book-read-line", value: "10万+", label: "漫画资源" },
  { icon: "ri-user-heart-line", value: "500万+", label: "活跃用户" },
  { icon: "ri-download-cloud-2-line", value: "1亿+", label: "累计下载" },
  { icon: "ri-star-line", value: "4.9", label: "用户评分" },
];

export default function FeatureSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-5 md:p-6 rounded-2xl bg-background-100/70 border border-background-200/50"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={`${stat.icon} text-xl`} />
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}